import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import summaryStopped from "../../images/summary_stop.svg";
import { waveformOffsetClass } from "./transcript.styles";

/**
 * Component shown when transcription has stopped
 * Uses the same visual format as SummarizeStopped but simplified for transcription
 */
const TranscribeStopped = () => {
  return (
    <Column alignmentHorizontal="start" width="100%" spacing="400" spacingInset="none">
      <img src={summaryStopped} alt="" className={waveformOffsetClass} />
      <Text type="h50" alignment="start">
        Transcription stopped
      </Text>
      <Text type="b200" alignment="start" color="secondary">
        Start taking notes if needed.
      </Text>
    </Column>
  );
};

export default TranscribeStopped;